import { ShortCode } from '@highereducation/wordpress';

interface SeoDataShortcodeProps {
  role?: string;
  children?: React.ReactNode;
  [key: string]: unknown;
}

/**
 * SeoDataShortcode — invisible marker that tags content for schema extraction.
 *
 * Replaces HTML `data-*` attributes (e.g. `data-howto-title`) with
 * `[hen-seo-data role="howto-title"]...[/hen-seo-data]`.
 *
 * Renders children as-is (no DOM output). The `role` value maps to the
 * old `data-{role}` attribute and is collected by `getSeoFromShortcodes`
 * at enrichment time.
 *
 * @example
 * [hen-seo-data role="howto-step"]
 *   [hen-ui-heading variant="h3"]Step 1: Complete a degree[/hen-ui-heading]
 * [/hen-seo-data]
 */
export const SeoDataShortcode: ShortCode<SeoDataShortcodeProps> = {
  balanced: true,
  component: ({ children }) => <>{children}</>,
};
